import { render, staticRenderFns } from "./SettingsAppointmentRemindersPage.vue?vue&type=template&id=60b083a8"
import script from "./SettingsAppointmentRemindersPage.vue?vue&type=script&lang=ts"
export * from "./SettingsAppointmentRemindersPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsAppointmentRemindersPage.vue?vue&type=style&index=0&id=60b083a8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports